var React = require('react');

function IconOpen (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"path-1-inside-1_4519_17","fill":"white","key":0},React.createElement("path",{"d":"M0 0H35V40H0V0Z"})),React.createElement("path",{"d":"M1 40V0H-1V40H1Z","fill":"#E5E5E5","mask":"url(#path-1-inside-1_4519_17)","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.5 21V27H18.5V21H24.5V19H18.5V13H16.5V19H10.5V21H16.5Z","fill":"#27788C","key":2})]);
}

IconOpen.defaultProps = {"width":"35","height":"40","viewBox":"0 0 35 40","fill":"none"};

module.exports = IconOpen;

IconOpen.default = IconOpen;
